<template>
  <div class="col-md-12">
    <form name="newDocument" @submit.prevent="handleSubmit()">
      <div class="modal-body">
        <label>Type:</label>

        <select name="Type" v-model="encodingData.Type" class="form-control">
          <option value>Select Type</option>
          <option
            v-for="option in types"
            v-bind:value="option.telephoneType"
            v-bind:key="option.telephoneType"
          >{{option.telephoneType}}</option>
        </select>

        <label>IMSI :</label>

        <input name="Imsi"
        v-validate="'max:50'"
        v-model="encodingData.Imsi" 
        class="form-control"
        :class="{ 'is-invalid': submitted && errors.has('Imsi') }" />
                    <div v-if="submitted && errors.has('Imsi')"
                         class="invalid-feedback">
                        {{ errors.first("Imsi") }}
                    </div>

        <label>Phone Number</label>
        <input name="PhoneNo"
        v-validate="'max:50'"
        v-model="encodingData.PhoneNo" 
        class="form-control"
        :class="{ 'is-invalid': submitted && errors.has('PhoneNo') }" />
                    <span v-if="submitted && errors.has('PhoneNo')"
                         class="invalid-feedback">
                        {{ errors.first("PhoneNo") }}
                    </span>

        <label>Country:</label>

        <select name="Country" v-model="encodingData.Country" class="form-control">
          <option value>Select Country</option>
          <option
            v-for="option in countries"
            v-bind:value="option.countryName"
            v-bind:key="option.countryName"
          >{{option.countryName}}</option>
        </select>

        <label>State:</label>

        <select name="SourceId" v-model="encodingData.State" class="form-control">
          <option value>Select State</option>
          <option
            v-for="option in provinces"
            v-bind:value="option.province"
            v-bind:key="option.province"
          >{{option.province}}</option>
        </select>

        <label>City :</label>

        <input type="text"
         v-validate="'max:50'"
        name="City" 
        v-model="encodingData.City" 
        class="form-control"
        :class="{ 'is-invalid': submitted && errors.has('City') }" />
                    <span v-if="submitted && errors.has('City')"
                         class="invalid-feedback">
                        {{ errors.first("City") }}
                    </span>

        <label>Address :</label>

        <input type="text"
        v-validate="'max:50'"
        name="Address" 
        v-model="encodingData.Address" 
        class="form-control"
        :class="{ 'is-invalid': submitted && errors.has('Address') }" />
                    <span v-if="submitted && errors.has('Address')"
                         class="invalid-feedback">
                        {{ errors.first("Address") }}
                    </span>

        <label>Comments :</label>

        <textarea
          name="Comments"
          v-model="encodingData.Comments"
          rows="5"
          cols="5"
          class="form-control"
        />
      </div>
      <div class="modal-footer">
        <button type="submit" class="btn btn-primary">Update</button>
      </div>
    </form>
  </div>
</template>

<script>

import {
  authHeader,
  responseCheck,
  notifyHelper,
  EncodeURL,
  DataURL,
  getlocalstorageCountry,
  getlocalstorageProvince,
  getlocalstorageTelephoneType
} from '../../helper'
import instance from '../../helper/http'
export default {
  data() {
    return {
      encodingData: {
        TelephoneId: '',
        Type: '',
        PhoneNo: '',
        Imsi: '',
        Country: '',
        State: '',
        City: '',
        Address: '',
        Comments: ''
      },
      countries: [],
      provinces: [],
      types: []
    }
  },
  props: {
    id: {
      type: String,
      required: true
    }
  },
  created: function() {
    this.getlibs()
  },
  methods: {
    getlibs() {
      
      this.countries = getlocalstorageCountry()
      this.provinces = getlocalstorageProvince()
      this.types = getlocalstorageTelephoneType()
      
      this.getTelephone()
    },
    handleSubmit() {
      let loader = this.$loading.show()
      instance
        .post(EncodeURL + 'updateTelephone', this.encodingData, {
          headers: authHeader()
        })
        .then(response => {
          if (response.data.error) {
            loader.hide()
            notifyHelper('error', response.data.message)
          } else {
            loader.hide()
            notifyHelper('success', response.data.message)
            this.$emit('done-edit-tel')
          }
        })
        .catch(function (error) {
          responseCheck(error.response.status);
        })
    },
    getTelephone() {
      
      instance
        .get(DataURL + 'telephone?telephoneID=' + this.id, {
          headers: authHeader()
        })
        .then(response => {
          if (response.data.error === false) {
            if (response.data.withdata) {
              let data = response.data.data
              this.encodingData.TelephoneId = data.telephoneId
              this.encodingData.Type = data.type
              this.encodingData.PhoneNo = data.phoneNo
              this.encodingData.Imsi = data.imsi
              this.encodingData.Country = data.country
              this.encodingData.State = data.state
              this.encodingData.City = data.city
              this.encodingData.Address = data.address
              this.encodingData.Comments = data.comments
            }
          }
        })
        .catch(function (error) {
          responseCheck(error.response.status);
        })
    }
  }
}
</script>
